<div class="w-100 flex-col justify-start items-stretch" [formGroup]="filenameForm">
  @if (isTestRule) {
    <div class="flex-row space-between items-center mb-2">
      <mat-slide-toggle labelPosition="before" color="primary" formControlName="sameAsProduction" >Same as production rule</mat-slide-toggle>
      @if (!sameAsProduction) {
        <button mat-button color="primary" class="uppercase" (click)="onCopyFromProductionRuleClick()">
          Copy From Production Rule
        </button>
      }
    </div>
  }
  @if (!isTestRule || !sameAsProduction) {
    <button mat-stroked-button color="primary" class="uppercase" (click)="onAddComponentClick()">
      Add Naming Component
    </button>
  }
  @if (formArr.length>0 && (!isTestRule || !sameAsProduction)) {
    <div formArrayName="components" cdkDropList class="component-list" (cdkDropListDropped)="drop($event)">
      @for (component of formArr.controls; track component; let i = $index) {
        <div [formGroupName]="i" class="component-box" cdkDrag>
          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-40" >
            <mat-label>Naming Component Type</mat-label>
            <mat-select placeholder="Select Type" formControlName="type" required>
              @for (componentType of fileNamingComponentTypes; track componentType) {
                <mat-option [value]="componentType">
                  {{componentType.label}}
                </mat-option>
              }
            </mat-select>
            @if (formGroup(i).get('type')?.errors?.['required']) {
              <mat-error>Selection is required</mat-error>
            }
          </mat-form-field>
          @if (component.get('type')!.value?.id==1) {
            <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-50" >
              <mat-label>Pattern</mat-label>
              <mat-select placeholder="Select Pattern" formControlName="value" required>
                @for (pattern of fileNamingDateTimePatterns; track pattern) {
                  <mat-option [value]="pattern">
                    {{pattern}}
                  </mat-option>
                }
              </mat-select>
              @if (formGroup(i).get('value')?.errors?.['required']) {
                <mat-error>Selection is required</mat-error>
              }
            </mat-form-field>
          }
          @if (component.get('type')!.value?.id==3) {
            <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-50" >
              <mat-label>Text</mat-label>
              <input matInput formControlName="value" autocomplete="off" type="text" required (mousedown)="$event.stopPropagation()">
              @if (formGroup(i).get('value')?.errors?.['required']) {
                <mat-error>Input is required</mat-error>
              }
            </mat-form-field>
          }
          @if (availableParameters() && component.get('type')!.value?.id==4) {
            <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-50" >
              <mat-label>Parameter</mat-label>
              <mat-select placeholder="Select Parameter" formControlName="value" required>
                @for (parameter of availableParameters(); track $index; let i = $index) {
                  <mat-option [value]="parameter">
                    {{parameter.name}} | {{parameter.index+1}}
                  </mat-option>
                }
              </mat-select>
              @if (formGroup(i).get('value')?.errors?.['required']) {
                <mat-error>Selection is required</mat-error>
              }
            </mat-form-field>
          }
          @if (component.get('type')!.value?.id==5) {
            <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-50" >
              <mat-label>Variable</mat-label>
              <mat-select placeholder="Select Variable" formControlName="value" required>
                @for (variable of availableCustomerVariables(); track $index; let i = $index) {
                  <mat-option [value]="variable.name">
                    {{variable.name}}
                  </mat-option>
                }
              </mat-select>
              @if (formGroup(i).get('value')?.errors?.['required']) {
                <mat-error>Selection is required</mat-error>
              }
            </mat-form-field>
          }
          @if (component.get('type')!.value?.id==6) {
            <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-50" >
              <mat-label>Custom Field</mat-label>
              <mat-select placeholder="Select Custom Field" formControlName="value" required>
                @for (metadataInfo of availableMetadataInfo(); track $index; let i = $index) {
                  <mat-option [value]="metadataInfo.name">
                    {{metadataInfo.name}}
                  </mat-option>
                }
              </mat-select>
              @if (formGroup(i).get('value')?.errors?.['required']) {
                <mat-error>Selection is required</mat-error>
              }
            </mat-form-field>
          }
          <div class="w-10 pt-3">
            <button mat-icon-button class="delete-button" (click)="deleteComponent(i)" matTooltip="Delete Component">
              <mat-icon>delete_outline</mat-icon>
            </button>
          </div>
        </div>
      }
    </div>
  }
  @if (namingPreview.length>0) {
    <span>Preview: {{namingPreview}}</span>
  }
</div>
